import EditSavedPaymentDetails from './EditSavedPaymentDetails';

export default EditSavedPaymentDetails;
